module.exports = __webpack_public_path__ + "media/images/icons/white-close-318908ea840d33bc8826e67a84842938.svg";